module.exports = __webpack_public_path__ + "img/logo.c0694715.png";